/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Day_SatInputs */

const cs_portals_day_sat = /** @type {(inputs: Portals_Day_SatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So`)
};

const en_portals_day_sat = /** @type {(inputs: Portals_Day_SatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sat`)
};

/**
* | output |
* | --- |
* | "Sat" |
*
* @param {Portals_Day_SatInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_day_sat = /** @type {((inputs?: Portals_Day_SatInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Day_SatInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_day_sat(inputs)
	return cs_portals_day_sat(inputs)
});